<div class="btn-group mr-1">
    <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
    >
        {{ translateSelectedCampTypeFilter }}
    </button>
    <div class="dropdown-menu dropdown-menu-right">
        @for (filter of campTypeValues; track filter) {
            <button
                class="dropdown-item hand"
                (click)="setCampTypeFilter(filter)"
            >
                {{ translateCampTypeFilter(filter) }}
            </button>
        }
    </div>
</div>

<div class="btn-group">
    <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
    >
        {{ translateSelectedFilter }}
    </button>
    <div class="dropdown-menu dropdown-menu-right">
        @for (filter of dateRangeValues; track filter) {
            <button class="dropdown-item hand" (click)="setFilter(filter)">
                {{ translateFilter(filter) }}
            </button>
        }
    </div>
</div>
